import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/theme.css';
import './styles/reviews.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { initMonitoring } from './services/monitoring';
import { installAccountSwitchGuard } from './services/authService';
import reportWebVitals from './reportWebVitals';

initMonitoring(); // מפעיל מעקב שגיאות בזמן אמת (רק אם הוגדר מפתח בסביבה)
installAccountSwitchGuard(); // "חזור" אחרי החלפת חשבון לא יחזיר לחשבון הקודם (bfcache)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
